<template>
  <div
    v-if="richTextContent"
    ref="checkboxWrapper"
    v-editable="blok"
    class="checkbox-content"
  >
    <div>
      <RichTextRenderer :document="richTextContent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { InlineCheckboxStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: InlineCheckboxStoryblok
}>()
const checkboxWrapper = ref<HTMLElement | null>(null)
const richTextContent = computed(() => props.blok.content)

onMounted(() => {
  nextTick(() => {
    setupDomCheckboxes()
  })
})

function setupDomCheckboxes() {
  if (import.meta.client) {
    const listItems = checkboxWrapper.value.querySelectorAll(
      'div > ul > li, div > h2, div > h3, div > h4, div > p',
    )

    for (const el of listItems) {
      el.addEventListener('click', () => {
        el.classList.toggle('checked')
      })
    }
  }
}
</script>

<style lang="less">
.apply-checkbox() {
  .relative();
  .text-body();

  padding: 0 0 0 @48px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &::before {
    .block();
    .absolute();
    .text-center();
    .font-xxs();

    content: '';
    top: 0;
    left: 0;
    width: @27px;
    height: @27px;
    padding: @4px 0 0;
    border-radius: @3px;
    border: @1px solid @color-form-border;
    background-color: @color-fill-normal;
    transition:
      color 0.2s ease-in-out,
      border-color 0.2s ease-in-out,
      background-color 0.2s ease-in-out;
    background-repeat: no-repeat;
    background-size: auto auto;
    background-position: center center;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='0.88em' height='1em' viewBox='0 0 448 512'%3E%3Cpath fill='%23F8F8F8' d='M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z'%3E%3C/path%3E%3C/svg%3E");
  }

  &.checked {
    .text-normal();

    &::before {
      background-color: @state-success;
      border-color: @state-success;
      color: @color-fill-normal;
    }
  }
}

.checkbox-content {
  margin: @36px 0 @24px;
  div {
    > ul {
      list-style: none;
      padding-left: 0;

      li {
        .apply-checkbox();
      }
    }

    > h2 {
      .apply-checkbox();

      &::before {
        top: @2px;
      }
    }

    > h3,
    > h4,
    > p {
      .apply-checkbox();
    }
  }
}
</style>
